<template>
  <div>
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>

    <!-- titulo y boton crear -->
    <v-row dense>
      <v-col cols="12" md="4">
        <AutocompleteComp textLabel="Nivel" v-model="filtro.id_nivel" :items="NivelFiltro" item-value="id"
          item-text="desc_nivel" @change="eventFiltroNivel" />
      </v-col>
      <v-col cols="12" md="4">
        <AutocompleteComp textLabel="Área" v-model="filtro.id_area" :items="AreaFiltro" item-value="id"
          item-text="desc_area" @change="filtrarView" />
      </v-col>

      <v-col cols="12" md="4" class="d-flex justify-end align-center">
        <TableButtonComp v-if="componenteEvento.agregar_submodulo" @click="addItem" textButton="Crear Curso" normalButton
          iconBut="fas fa-plus" />
      </v-col>


    </v-row>

    <v-row>
      <v-col cols="12" v-if="mostrarMensaje">
        <v-card outlined>
          <v-card-text style="min-height:200px" class="text-center d-flex align-center justify-center">
            Aún no has agregado ningún curso a configuración del sistema
          </v-card-text>
        </v-card>
      </v-col>
      <!-- <v-alert color="#ffbc00" icon="fas fa-exclamation-triangle" dark border="left" prominent elevation="5" dense>
          <span class="font-weight-black">Aún no has agregado ningún curso a configuración del sistema
          </span>
        </v-alert> -->

      <v-col cols="12" v-for="item in Cursos" :key="item.id">
        <v-alert dense :style="{ background: item.color_nivel, color: '#fff' }"><b>NIVEL:</b> {{ item.desc_nivel }}
        </v-alert>
        <v-row>
          <v-col cols="12" sm="6" xs="12" md="4" v-for="(curso, i) in item.curso" :key="i" class="d-flex justify-center">
            <v-card width="240" elevation="7" :style="{ 'border-left': 'solid 3px' + item.color_nivel }">
              <v-list-item>
                <v-list-item-avatar class="ml-0 mr-1" size="50" :color="curso.color_curso">
                  <v-icon dark>{{ curso.icono_curso }}</v-icon>
                </v-list-item-avatar>

                <v-list-item-content class="py-0">
                  <span class="mb-1 font-weight-bold black--text">
                    <h5>{{ curso.desc_curso }}</h5>
                  </span>
                  <v-list-item-title class="caption">Área: {{ curso.desc_area }}</v-list-item-title>
                  <!-- <v-list-item-title class="headline mb-1">{{item.desc_curso}}</v-list-item-title> -->
                </v-list-item-content>
              </v-list-item>

              <v-card-text class="white--text" :style="{ background: curso.color_nivel }" id="text">{{ curso.nivel }} - {{
                curso.grado }}</v-card-text>

              <v-card-actions>
                <v-row>
                  <v-spacer></v-spacer>

                  <v-col cols="12" md="6" class="d-flex justify-end gap-10px">
                    <TableButtonComp v-if="componenteEvento.editar_submodulo" @click="editCurso(curso)" editButton
                      tooltipText="Editar curso" />


                    <TableButtonComp v-if="componenteEvento.borrar_submodulo" @click="deleteConfirm(curso)" deleteButton
                      tooltipText="Eliminar curso" />

                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-----modal AGREGAR EDITAR -->
    <v-form ref="formDatos" lazy-validation>
      <ComunDialogComp v-model="dialog" max-width="800" :title="formTitle" @close-modal="dialog = false">
        <template v-slot:body>
          <v-row class="pb-4">
            <v-col cols="12" md="12" class="mt-1 pb-0">
              <AutocompleteComp textLabel="Nivel" v-model="dataForm.id_nivel" :items="NivelesMantenimiento"
                item-value="id" item-text="desc_nivel" :readonly="evento == 'editar'"
                @change="eventNivel(dataForm.id_nivel)" :rules="validationRules.validateNivel" />
            </v-col>

            <v-col cols="12" md="6" class="py-0">
              <AutocompleteComp textLabel="Área" v-model="dataForm.id_area" :items="Areas_Nivel" item-value="id"
                item-text="desc_area" :readonly="evento == 'editar'" @change="bringCurso(dataForm.id_area)"
                :rules="validationRules.validateArea" />
            </v-col>

            <v-col cols="12" md="6" class="py-0">
              <AutocompleteComp textLabel="Grado" v-model="dataForm.id_grado" :items="Grados_nivel" item-value="id"
                item-text="desc_grado" :readonly="evento == 'editar'" multiple :rules="validationRules.validateGrado" />
            </v-col>

            <!-- Acá debe traer los cursos de INTELIGENIO para hacerle una referencia -->
            <v-col cols="12" md="11" class="py-0">

              <textfieldComp v-if="evento == 'editar'" textLabel="Referencia del curso de Inteligenio"
                v-model="dataForm.desc_curso_ck1" readonly/>

                <v-autocomplete
                  v-if="evento == 'agregar'"
                  v-model="dataForm.ck1_curso_array"
                  :items="Curso_Minedu_individual"
                  item-text="desc_curso"
                  item-value="id_ck1_cursos"
                  label="Referencia del curso de Inteligenio"
                  @change="setNombreCurso($event)"
                  return-object
                  :rules="validationRules.validateCurso"
                ></v-autocomplete> 


            </v-col>

            <v-col cols="12" md="1" class="py-0">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on">fa-info-circle</v-icon>
                </template>
                Al hacer referencia a un curso de Inteligenio se tiene acceso a los contenidos que están vinculados a él.
              </v-tooltip>
            </v-col>


            <v-col cols="12" md="6" class="py-0">
              <textfieldComp textLabel="Nombre del curso" v-model="dataForm.desc_curso"
                :rules="validationRules.validarnameCursos" />
            </v-col>


          </v-row>

          <v-row>
            <v-col cols="12" md="6" class="py-0">
              <v-row class="pb-6">
                <v-col>
                  <label class="black--text">
                    <h3>Seleccionar color</h3>
                  </label>
                </v-col>
              </v-row>

              <v-color-picker v-model="dataForm.color_curso" width="400px"></v-color-picker>
            </v-col>

            <v-col cols="12" md="6" class="py-0">
              <v-row>
                <v-col>
                  <label class="black--text">
                    <h3>Seleccionar ícono</h3>
                  </label>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="2" md="2" lg="2" v-for="icon of iconos" :key="icon.id">
                  <v-card class="text-center pt-1 pb-1" @click="agregarIcono(icon.nombre)">
                    <v-icon :style="{ color: dataForm.color_curso }">{{
                      icon.nombre
                    }}</v-icon>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="d-flex justify-center">
              <v-card :color="dataForm.color_curso" class="px-2 py-2 text-center" style="width: 60px">
                <v-icon large dark>{{ dataForm.icono_curso }}</v-icon>
              </v-card>
            </v-col>
          </v-row>
        </template>

        <template v-slot:actions>
          <v-spacer></v-spacer>

          <TableButtonComp v-if="evento == 'editar'" @click="updateCurso(dataForm.id)" iconBut="fas fa-save"
            textButton="Guardar cambios" normalButton />

          <TableButtonComp v-if="evento == 'agregar'" @click="saveCurso" textButton="Guardar" iconBut="fas fa-save"
            normalButton />
        </template>
      </ComunDialogComp>
    </v-form>
    <!---------fin del modal ------->
    <!-- //////////////Modal para confirmar eliminacion /////////////////////    -->
    <ComunDialogComp v-model="dialog_delete" Deletedialog titleWindow="Eliminar curso"
      @close-modal="dialog_delete = false" @cancel-item="dialog_delete = false" @delete-item="deleteCurso">
      <template v-slot:body>
        <p class="text-h6 text-md-h5 text-lg-h6">
          ¿Está seguro de eliminar este registro?
        </p>
        <v-chip color="primary" label dense>
          {{ name_delete }}
        </v-chip>
      </template>
    </ComunDialogComp>

    <!-- fin de modal de borrar registro-->
  </div>
</template>

<script>
import axios from "../../helpers/axios";
import ComunDialogComp from "../../components/ComponentsEst/ComunDialogComp.vue";
import AutocompleteComp from "../../components/ComponentsEst/AutocompleteComp.vue";
import TableButtonComp from "../../components/ComponentsEst/TableButtonComp.vue";
import textfieldComp from "../../components/ComponentsEst/textfieldComp.vue";
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";
import { validationRules } from "../../helpers/validatorHelpers.js";

export default {
  components: {
    ComunDialogComp,
    AutocompleteComp,
    TableButtonComp,
    textfieldComp,
  },
  name: "cursos",
  data: () => ({
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    paramComponente: { id_submodulo: 37, id_modulo: 5 }, //sud_modulo y modulo
    datoLogin: sessionStorage, // variables de sesion del usuario
    ////////////////////////////////////////////////////////
    filtro: { id_nivel: null },
    NivelFiltro: [],
    AreaFiltro: [],
    Cursos: [],
    mostrarMensaje: false,
    //validaciones de formulario
    rul: {
      required: (value) => !!value || "Campo requerido",
      inputReq: (value) => !!value || "Campo requerido",
      selectReq: (value) => !!value || "Debe seleccionar un campo de la lista",
      email: (value) =>
        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) ||
        "El correo Electrónico es incorrecto",
      min4: (v) => (v || "").length >= 4 || "Mínimo 4 caracteres",
      min6: (v) => (v || "").length >= 6 || "Mínimo 6 caracteres",
      min8: (v) => (v || "").length >= 8 || "Mínimo 8 caracteres",
      max10: (v) => (v || "").length <= 10 || "Máximo 10 caracteres",
      max11: (v) => (v || "").length <= 11 || "Máximo 11 caracteres",
      max12: (v) => (v || "").length <= 12 || "Máximo 12 caracteres",
      max20: (v) => (v || "").length <= 20 || "Máximo 20 caracteres",
      max30: (v) => (v || "").length <= 30 || "Máximo 30 caracteres",
      max50: (v) => (v || "").length <= 50 || "Máximo 50 caracteres",
      max60: (v) => (v || "").length <= 60 || "Máximo 60 caracteres",
      max100: (v) => (v || "").length <= 100 || "Máximo 100 caracteres",
      max150: (v) => (v || "").length <= 150 || "Máximo 150 caracteres",
      email_null: (value) => {
        if (value == "") {
          return false;
        } else {
          const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/;
          return pattern.test(value) || "El correo Electrónico es incorrecto";
        }
      },
    },
    // modal agregar editar curso
    dialog: false,
    evento: "",
    dataForm: [],
    NivelesMantenimiento: [],
    Areas_Nivel: [],
    Cursos_Minedu: [],
    Curso_Minedu_individual: [],
    Grados_nivel: [],
    disabledArea: true,
    disabledGrado: true,
    
    ////////////////////////////
    // modal confirmacion
    dialog_delete: false,
    name_delete: "",
    id_delete: null,
    ////////////////////////////
  }),

  computed: {
    validationRules() {
      return validationRules;
    },

    ...mapGetters("login", ["componenteEvento"]),

    formTitle() {
      return this.evento === "agregar" ? "Crear curso" : "Editar curso ";
    },

    ...mapState({
      iconos: (state) => state.areas.iconos,
    }),
  },

  mounted() {
    this.loadMain();
  },

  created() {
    this.actualizarParamentro();
  },
  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //----- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),

    async loadMain() {
      this.filtrarView();

      // CARGA LOS NIVELES DEL COLEGIO
try {
  let res = await axios.get(`/mantenimiento/nivel/${this.datoLogin.id_colegio}`);
  let objectNew = JSON.parse(JSON.stringify(res.data));
  objectNew.unshift({
    id: null,
    desc_nivel: "Todos",
  });
  this.NivelFiltro = objectNew;
} catch (e) {
  this.setEnviarMens({ tipo: "E", mensaje: e.message || e.toString(), tiempo: null });
}
    },

    setNombreCurso({desc_curso}){

      this.dataForm.desc_curso = desc_curso

    },

    //-------mostrar registros de cursos de mantenimiento------------
    async filtrarView() {
      this.mostrarMensaje = false;
      this.filtro.id_colegio = this.datoLogin.id_colegio;
      try {
        let response = await axios.post(
          "/mantenimiento/curso/getMain/",
          this.filtro
        );
        this.Cursos = response.data;
        if (this.Cursos.length === 0) {
          this.mostrarMensaje = true;
        }
      } catch (e) {
       this.setEnviarMens({ tipo: "E", mensaje: e.message || e.toString(), tiempo: null });
      }
    },
    async eventFiltroNivel() {
      try {
        let res = await axios.get(`/mantenimiento/area/list/areaColegioXNivel/${this.filtro.id_nivel}`);
        this.filtro.id_area = null;
        var objectNew = [];
        if (res.data.length > 0) {
          objectNew = JSON.parse(JSON.stringify(res.data));
          objectNew.unshift({
            id: null,
            desc_area: "Todos",
          });
        }
        this.AreaFiltro = objectNew;
      } catch (e) {
         this.setEnviarMens({ tipo: "E", mensaje: e.message || e.toString(), tiempo: null });
      }

      this.filtrarView();
    },

    async limpiarForm() {
      this.dataForm = {
        id_colegio: this.datoLogin.id_colegio,
        id_area: 0,
        id_grado: 0,
        desc_curso: "",
        id_us_ing: this.datoLogin.id,
        fec_us_ing: "",
        id_us_mod: this.datoLogin.id,
        fec_us_mod: "",
        icono_curso: "",
        color_curso: "#0277BD",
        estado: 1,
        ck1: false,
      };

      this.NivelesMantenimiento = [];
      this.Areas_Nivel = [];
      this.Grados_nivel = [];
      this.Cursos_Minedu = [];
      this.Curso_Minedu_individual = [];

      this.disabledArea = true;
      this.disabledGrado = true;

      this.$refs.formDatos.resetValidation();
    },

    addItem() {
      this.limpiarForm();
      this.evento = "agregar";
      this.dialog = true;

      this.getNivelesMantenimiento();
    },

    //---------Niveles de mantenimiento -------
    async getNivelesMantenimiento() {
      var id = this.datoLogin.id_colegio;

      try {
        let response = await axios.get("/mantenimiento/nivel/" + id + "");
        this.NivelesMantenimiento = response.data;
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: e.message || e.toString(), tiempo: null });

      }
    },
    /////// funcion para traer las areas y grados por nivel ////////
    async eventNivel(id) {

      this.dataForm.id_grado = null;
      this.dataForm.id_area = null;
      this.Curso_Minedu_individual = [];
      this.Cursos_Minedu = [];

      this.$refs.formDatos.resetValidation();

      this.disabledGrado = true;

      let params = { id_nivel: id, id_colegio: this.datoLogin.id_colegio };

      try {
        let response = await axios.post(
          "mantenimiento/curso/getGradoAreaXNivel/",
          params
        );

        // this.Grados_nivel = response.data.grado;
        this.Areas_Nivel = response.data.area;

        if (this.evento == "agregar") {
          // this.disabledGrado == true ? this.Grados_nivel.length === 0 : false;
          this.disabledArea == true ? this.Areas_Nivel.length === 0 : false;
        } else {
          this.disabledGrado = true;
          this.disabledArea = true;
        }
      } catch (e) {
        this.Grados_nivel = [];
        this.Areas_Nivel = [];
        this.setEnviarMens({ tipo: "E", mensaje: e.message || e.toString(), tiempo: null });
      }
    },

    //Traer los cursos de INGELIGENIO
    async bringCurso(id_area) {

      console.log({id_area});

      try {
        //Aca me traigo el icono y el color (a pedido de dany)
        let areaSeleccionada = this.Areas_Nivel.filter((e) => {
          return e.id == this.dataForm.id_area
        });

        this.dataForm.icono_curso = areaSeleccionada[0].icono_area;
        this.dataForm.color_curso = areaSeleccionada[0].color_area;

    const response = await axios.get(`/mantenimiento/curso/getCursosInteligenioColegio/${id_area}/${this.datoLogin.id_colegio}`);

        this.Grados_nivel = response.data.grados;
        this.Cursos_Minedu = response.data.cursos;

        if (this.Grados_nivel === 0) {
      this.setEnviarMens({ tipo: "W", mensaje: "No existen grados en Manager", tiempo: null });
        }

     
        this.Curso_Minedu_individual = Object.values(this.Cursos_Minedu.reduce((item, {id, desc_curso}) => {

          const desc = desc_curso.trim().toLowerCase();

          item[desc] = item[desc] || { desc_curso:desc, id_ck1_cursos: [] };
          item[desc].id_ck1_cursos.push(id);

          return item;

        }, {}));

        console.log('this.Curso_Minedu_individual',this.Curso_Minedu_individual);

      } catch (error) {
        console.log('Error al traer los cursos de inteligenio. ' + error);
      }
    },

    ///////////////////////////////////////////////////////////
    //-----------crear Cursos --------------
    async saveCurso() {
      if (this.$refs.formDatos.validate()) {

        if (!this.dataForm.icono_curso) {
          this.setEnviarMens({
            tipo: "W",
            mensaje: "Seleccionar un Ícono",
            tiempo: null,
          });

        } else {

          let params = this.dataForm;
          try {

            let filtradoGrado = this.Cursos_Minedu.filter(curso =>
              params.id_grado.includes(curso.id_grado_mant)
            )
           
            const filtradoRefenciaCurso = filtradoGrado.filter(objeto => params.ck1_curso_array.id_ck1_cursos.includes(objeto.id));
            params.cursosSeleccionados = filtradoRefenciaCurso;
          
            let res = await axios.post("/mantenimiento/curso/addCurso", params);
            if (res.data.messageT == "S") {
              this.filtrarView();
              this.limpiarForm();
              this.dialog = false;
            }

            this.setEnviarMens({
              tipo: res.data.messageT,
              mensaje: res.data.message,
              tiempo: null,
            });

          } catch (e) {
            // thELIMIis.setEnviarMens({ tipo: "E", mensaje: ${e}, tiempo: null })
          }
        }
      } else {
        this.setEnviarMens({
          tipo: "W",
          mensaje: "Debe completar todos los campos requeridos",
          tiempo: null
        });
      }
    },

    editCurso(item) {
      this.limpiarForm();
      this.evento = "editar";

      this.dialog = true;
      this.getNivelesMantenimiento();
      this.eventNivel(item.id_nivel);

      this.bringCurso(item.id_area)
      this.dataForm = Object.assign({}, item);
      this.dataForm.id_us_mod = this.datoLogin.id;

    },

    //--------------editar curso--------------
    async updateCurso(id) {
      if (this.$refs.formDatos.validate()) {
        if (!this.dataForm.icono_curso) {
          this.setEnviarMens({
            tipo: "W",
            mensaje: "Seleccionar un Ícono",
            tiempo: null,
          });
        } else {
          try {
            let res = await axios.put(
              "/mantenimiento/curso/" + id,
              this.dataForm
            );
            if (res.data.messageT == "S") {
              this.filtrarView();
              this.limpiarForm();
              this.dialog = false;
            }
            this.setEnviarMens({
              tipo: res.data.messageT,
              mensaje: res.data.message,
              tiempo: null,
            });
          } catch (e) {
            this.setEnviarMens({ tipo: "E", mensaje: e.message || e.toString(), tiempo: null });
          }
        }
      } else {
this.setEnviarMens({
  tipo: "W",
  mensaje: "Debe de ingresar todos los campos requeridos",
  tiempo: null
});

      }
    },
    /////  funcion para confirmar delete
    deleteConfirm(item) {
      this.dialog_delete = true;
      this.id_delete = item.id;
     this.name_delete = `Curso: ${item.desc_curso}`;
    },
    //------------borrar curso -------------
    async deleteCurso() {
      try {
        let res = await axios.delete("/mantenimiento/curso/" + this.id_delete);
        if (res.data.messageT == "S") {
          this.dialog_delete = false;
          this.filtrarView();
        }
        this.setEnviarMens({
          tipo: res.data.messageT,
          mensaje: res.data.message,
          tiempo: null,
        });
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: e.message || e.toString(), tiempo: null });
      }
    },
    agregarIcono(icono) {
      this.dataForm.icono_curso = icono;
    },
  },
};
</script>